// extracted by mini-css-extract-plugin
export default {"root":"SearchInput_root__poxyY","input":"SearchInput_input__pvo3q"};